
      import Set from './set.vue'
      import type { App, Plugin } from 'vue'

      export const SetPlugin: Plugin = {
        install(app: App) {
          app.component('Set', Set)
        },
      }
      export { Set }
      